import { render } from "./PriceComparison.vue?vue&type=template&id=0ce1aa60&scoped=true"
import script from "./PriceComparison.vue?vue&type=script&lang=js"
export * from "./PriceComparison.vue?vue&type=script&lang=js"

import "./PriceComparison.vue?vue&type=style&index=0&id=0ce1aa60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ce1aa60"]])

export default __exports__